module.exports = __webpack_public_path__ + "img/pr-2.ef574c88.png";